module.exports = __webpack_public_path__ + "img/arrow.2b59d5cf.svg";